import React, { Component } from 'react';
import { Table, Input } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { HeaderTableMasterDataAccomodationItem } from '../../../../components/table/headerTabel';
import {
  datasetPagination,
  getNumberFromTo,
} from '../../../../scripts/pagination';
import FilterData from '../../../../scripts/filterDataTable';
import Pagination from '../../../../components/common/pagination';
class TableMasterDataAccomodationItem extends Component {
  constructor(props) {
    super(props);
    this.currentIndex = 0;
    this.state = {
      searchInput: '',
      activePage: 1,
    };
  }
  static propTypes = {
    data: PropTypes.array,
  };
  handleChange = (e, { name, value }) =>
    this.setState({ [name]: value, activePage: 1 });
  pageChange = (e, { activePage }) => {
    this.setState({ activePage });
  };
  render() {
    let filterData = FilterData(
      this.props.listData,
      'Name',
      this.state.searchInput
    );
    let pagedData = datasetPagination(filterData, 3);
    let listData = pagedData[this.state.activePage - 1];

    const props = this.props;

    let { numbersFrom, numbersTo } = getNumberFromTo(
      listData,
      this.state.activePage,
      3
    );
    return (
      <div>
        <Input
          icon="search"
          placeholder="search"
          name="searchInput"
          value={this.state.searchInput}
          onChange={this.handleChange}
        />
        <Table basic="very" selectable fixed>
          <div style={{ overflow: 'auto' }}>
            <Table.Header>
              <Table.Row>
                {HeaderTableMasterDataAccomodationItem.map(
                  (headTableContent, index) => {
                    return (
                      <Table.HeaderCell key={index}>
                        {headTableContent}
                      </Table.HeaderCell>
                    );
                  }
                )}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {listData &&
                listData.map((item, idx) => {
                  return (
                    <Table.Row key={idx}>
                      <Table.Cell component="th" scope="row" width={1}>
                        {item.Name}
                      </Table.Cell>
                      <Table.Cell> {item.ItemDesc}</Table.Cell>
                      <Table.Cell> {item.IsPromo}</Table.Cell>
                      <Table.Cell> {item.CompanyCode}</Table.Cell>
                      <Table.Cell> {item.AccommodationItemType}</Table.Cell>
                      <Table.Cell> {item.Currency}</Table.Cell>
                      <Table.Cell> {item.Price}</Table.Cell>
                      <Table.Cell> {item.StartDate}</Table.Cell>
                      {/* Convert Date */}
                      <Table.Cell> {item.EndDate}</Table.Cell>
                      {/* Convert Date */}
                      <Table.Cell> {item.CuttOffDay}</Table.Cell>
                      <Table.Cell> {item.CutOffDate}</Table.Cell>
                      {/* Convert Date */}
                      <Table.Cell> {item.MinimumNights}</Table.Cell>
                      <Table.Cell> {item.Rank}</Table.Cell>
                      <Table.Cell> {item.ServiceType}</Table.Cell>
                    </Table.Row>
                  );
                })}
            </Table.Body>
            {/* {pagedData &&
              pagedData.length > 1 && ( */}
            {/* <Table.Footer> */}
            <Pagination
              // totalPages={pagedData.length}
              // onPageChange={this.pageChange}
              // activePage={this.state.activePage}

              pagedData={pagedData}
              numbersTo={numbersTo}
              numbersFrom={numbersFrom}
              data={props.listData}
              pageChange={this.pageChange}
              activePage={this.state.activePage}
            />
            {/* </Table.Footer> */}
            {/* )} */}
          </div>
        </Table>
      </div>
    );
  }
}

TableMasterDataAccomodationItem.propTypes = {
  listData: PropTypes.array,
  pageChange: PropTypes.func,
  activePage: PropTypes.string,
};
export default TableMasterDataAccomodationItem;
